export const sliderItems = [
  {
    id: 1,
    img: "/images/slider/3.png",
    title: "SUMMER SALE",
    desc: "DON'T COMPROMISE ON STYLE. GET 10% FLAT DISCOUNT NOW",
    bg: "f5fafd",
  },
  {
    id: 2,
    img: "/images/slider/2.png",
    title: "AUTUMN COLLECTION",
    desc: "DON'T COMPROMISE ON STYLE. GET 10% FLAT DISCOUNT NOW",
    bg: "fcf1ed",
  },
  {
    id: 3,
    img: "/images/slider/1.png",
    title: "WINTER SALE",
    desc: "DON'T COMPROMISE ON STYLE. GET 10% FLAT DISCOUNT NOW",
    bg: "fbf0f4",
  },
];

export const categories = [
  {
    id: 1,
    img: "/images/category/1.jpg",
    title: "SHIRT STYLES",
    slug: "shirt",
  },
  {
    id: 2,
    img: "/images/category/2.jpg",
    title: "CASUAL GOWNS",
    slug: "gown",
  },
  {
    id: 3,
    img: "/images/category/3.jpg",
    title: "JACKETS",
    slug: "jacket",
  },
];

export const popularProducts = [
  {
    id: 1,
    title: "Blue Suit",
    img: "/images/popularProducts/1.png",
    price: 55000,
    color: ["darkBlue", "black", "grey"],
    size: ["50", "48", "46"],
    category: ["fashion", "male", "suit"],
    quantity: 1,
    stock_quantity: 50,
    iswishList: false,
    desc: "This is the best fabric available and it is made in Turkey; carefully tailored by the best. It's an attire that makes you stand out. Purchase now for your deluxe experience.",
  },
  {
    id: 2,
    title: "T-Shirt",
    img: "/images/popularProducts/2.png",
    price: 10000,
    color: ["black", "blue", "white"],
    size: ["L", "M", "S"],
    category: ["fashion", "male", "female", "", "unisex", "shirt", "t-shirt", "top", "casual"],
    quantity: 1,
    stock_quantity: 50,
    iswishList: false,
    desc: "The Unique T-shirt in the world. It was customized by Louis Vuitton for high-end customers",
  },
  {
    id: 3,
    title: "Blouse",
    img: "/images/popularProducts/3.png",
    price: 15000,
    color: ["grey", "pink", "lemongreen"],
    size: ["XL", "L", "M", "S"],
    category: ["fashion", "female", "blouse", "casual", "top"],
    quantity: 1,
    stock_quantity: 50,
    iswishList: false,
    desc: "Stylishly designed casual blouse for a lady of quality and taste",
  },
  {
    id: 4,
    title: "Skirt",
    img: "/images/popularProducts/4.png",
    price: 10000,
    color: ["white", "red"],
    size: ["L", "M", "S"],
    category: ["fashion", "female", "skirt", "casual"],
    quantity: 1,
    stock_quantity: 50,
    iswishList: false,
    desc: "Multi-patterned skirt, fashioned to show your curves and beauty",
  },
  {
    id: 5,
    title: "Hand Bag",
    img: "/images/popularProducts/5.png",
    price: 30000,
    color: ["teal", "brown", "orange"],
    size: ["M"],
    category: ["fashion", "female", "bag", "handbag", "purse", "casual"],
    quantity: 1,
    stock_quantity: 50,
    iswishList: false,
    desc: "High quality hand bag for the royal class. Durable and furnished with extra panache",
  },
  {
    id: 6,
    title: "Cool Jacket",
    img: "/images/popularProducts/6.png",
    price: 30000,
    color: ["black", "grey", "brown"],
    size: ["L", "M", "S"],
    category: ["fashion", "male", "jacket", "casual", "top", "unisex", "shirt"],
    quantity: 1,
    stock_quantity: 50,
    iswishList: false,
    desc: "Jeans jacket sewn to fit your body build and makes you stand out",
  },
  {
    id: 7,
    title: "Female Suit",
    img: "/images/popularProducts/7.png",
    price: 65000,
    color: ["darkblue", "grey", "black"],
    size: ["XL", "L", "M", "S"],
    category: ["fashion", "female", "suit", "corporate", "unisex", "shirt", "top"],
    quantity: 1,
    stock_quantity: 50,
    iswishList: false,
    desc: "High quality suit for ladies, which is comfortable for the corporate events and pronounces your beauty",
  },
  {
    id: 8,
    title: "Wrist Watch",
    img: "/images/popularProducts/8.png",
    price: 50000,
    color: ["gold", "silver"],
    size: ["M"],
    category: ["fashion", "wristwatch", "unisex", "watch", "accessory", "jewelry"],
    quantity: 1,
    stock_quantity: 50,
    iswishList: false,
    desc: "Elegant wrist watch for men of high taste",
  },

  {
    id: 9,
    title: "Leather jacket",
    img: "/images/popularProducts/9.png",
    price: 20000,
    color: ["black", "brown"],
    size: ["L", "M", "S"],
    category: ["fashion", "male", "jacket", "casual", "top", "unisex", "shirt"],
    quantity: 1,
    stock_quantity: 50,
    iswishList: false,
    desc: "High quality leather jacket made by Luis Vutton. It's a jacket that makes you stand out and potrays your class elegantly",
  },
  {
    id: 10,
    title: "Female Leather Jacket",
    img: "/images/popularProducts/10.png",
    price: 20000,
    color: ["black", "brown", "maroon"],
    size: ["L", "M", "S"],
    category: ["fashion", "female", "jacket", "casual", "top", "unisex", "shirt"],
    quantity: 1,
    stock_quantity: 50,
    iswishList: false,
    desc: "High quality leather jacket made by Luis Vutton, and is tailored made for classy women. It makes you stand out and potrays your elegance",
  },
  {
    id: 11,
    title: "Cute Gown",
    img: "/images/popularProducts/11.png",
    price: 15000,
    color: ["black", "brown", "maroon"],
    size: ["L", "M"],
    category: ["fashion", "female", "gown", "casual"],
    quantity: 1,
    stock_quantity: 50,
    iswishList: false,
    desc: "A gown that makes you stand out and potrays your elegance. Tailor made for confident women",
  },
  {
    id: 12,
    title: "Sleeveless Gown",
    img: "/images/popularProducts/12.png",
    price: 15000,
    color: ["maroon"],
    size: ["L", "M"],
    category: ["fashion", "female", "gown"],
    quantity: 1,
    stock_quantity: 50,
    iswishList: false,
    desc: "A dinner gown that makes you stand out and potrays your elegance. Tailor made for confident women",
  },
  {
    id: 13,
    title: "Female Jeans Jacket",
    img: "/images/popularProducts/13.png",
    price: 10000,
    color: ["black", "blue", "maroon"],
    size: ["L", "M"],
    category: ["fashion", "female", "jacket", "casual", "top", "shirt"],
    quantity: 1,
    stock_quantity: 50,
    iswishList: false,
    desc: "Cute jacket for the outgoing woman. It pronounces your beauty and makes you stand out",
  }
];
